// extracted by mini-css-extract-plugin
export default {"errorCaption":"image_errorCaption__74ED4","errorText":"image_errorText__K4bXy","errorSpan":"image_errorSpan__DNEZK"};